module.exports = __webpack_public_path__ + "img/sawtooth-wave.39ed97b0.svg";